var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.333 8.1H3.556v1.8h1.777V8.1zm3.556 0H7.11v1.8h1.78V8.1zm3.555 0h-1.777v1.8h1.777V8.1zm1.778-6.3h-.889V0h-1.777v1.8H4.444V0H2.667v1.8h-.89C.792 1.8.01 2.61.01 3.6L0 16.2c0 .99.791 1.8 1.778 1.8h12.444C15.2 18 16 17.19 16 16.2V3.6c0-.99-.8-1.8-1.778-1.8zm0 14.4H1.778V6.3h12.444v9.9z","fill":"currentColor","fillRule":"evenodd"}));
}

Calendar.defaultProps = {"width":"16","height":"18","viewBox":"0 0 16 18"};

module.exports = Calendar;

Calendar.default = Calendar;
